import { FetchContactByIdResponse } from "src/types/settings/integrations/hubspot";
import _ from 'lodash';
import {
  FETCH_CONTACT_BY_ID,
  FETCH_CONTACT_BY_ID_SUCCEDDED,
  FETCH_CONTACT_BY_ID_FAILED,
  FETCH_HUBSPOT_RECOMMENDED_ASSETS,
  FETCHING_HUBSPOT_RECOMMENDED_ASSETS_SUCCEDDED,
  FETCHING_HUBSPOT_RECOMMENDED_ASSETS_FAILED,
  FETCH_HUBSPOT_SHARES_FOR_OPPORTUNITY,
  FETCHING_HUBSPOT_SHARES_FOR_OPPORTUNITY_SUCCEDDED,
  FETCHING_HUBSPOT_SHARES_FOR_OPPORTUNITY_FAILED,
  INVALIDATE_HUBSPOT_RECOMMENDED_ASSETS,
  INVALIDATE_HUBSPOT_SHARES_FOR_OPPORTUNITY,
  INVALIDATE_HUBSPOT_CONTACT
} from "../../actions/actionTypes";

interface IInitialState {
  contact: {
    loading: boolean;
    error: any;
    succeeded: boolean;
    record: FetchContactByIdResponse | null;
  },
  recommendedAssets: {
    loading: boolean;
    error: any;
    succeeded: boolean;
    records: any;
    pagination: {
      currentPage: number;
      totalPages: number;
      recordsPerPage: number;
      totalRecords: number;
    };
  },
  sharesForOpportunity: {
    loading: boolean;
    error: any;
    succeeded: boolean;
    records: any;
  }
}

const initialState: IInitialState = {
  contact: {
    loading: false,
    error: null,
    succeeded: false,
    record: null,
  },
  recommendedAssets: {
    loading: false,
    error: null,
    succeeded: false,
    records: null,
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 0,
      totalRecords: 0,
    },
  },
  sharesForOpportunity: {
    loading: false,
    error: null,
    succeeded: false,
    records: [],
  },
};

export const hubspotReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_CONTACT_BY_ID:
      return {
        ...state,
        contact: {
          ...state.contact,
          loading: true,
          error: null,
          succeeded: false,
        },
      };
    case FETCH_CONTACT_BY_ID_SUCCEDDED:
      return {
        ...state,
        contact: {
          ...state.contact,
          loading: false,
          error: null,
          succeeded: true,
          record: action.payload,
        },
      };
    case FETCH_CONTACT_BY_ID_FAILED:
      return {
        ...state,
        contact: {
          ...state.contact,
          loading: false,
          error: action.payload.error,
          succeeded: false,
        },
      };

    case FETCH_HUBSPOT_RECOMMENDED_ASSETS:
      return {
        ...state,
        recommendedAssets: {
          ...state.recommendedAssets,
          loading: true,
          error: null,
          succeeded: false,
        },
      };
    case FETCHING_HUBSPOT_RECOMMENDED_ASSETS_SUCCEDDED:
      return {
        ...state,
        recommendedAssets: {
          ...state.recommendedAssets,
          loading: false,
          error: null,
          succeeded: true,
          records: _.get(action.payload, 'assets', []),
        },
      };
    case FETCHING_HUBSPOT_RECOMMENDED_ASSETS_FAILED:
      return {
        ...state,
        recommendedAssets: {
          ...state.recommendedAssets,
          loading: false,
          error: action.payload.error,
          succeeded: false,
        },
      };

    case FETCH_HUBSPOT_SHARES_FOR_OPPORTUNITY:
      return {
        ...state,
        sharesForOpportunity: {
          ...state.sharesForOpportunity,
          loading: true,
          error: null,
          succeeded: false,
        },
      };
    case FETCHING_HUBSPOT_SHARES_FOR_OPPORTUNITY_SUCCEDDED:
      return {
        ...state,
        sharesForOpportunity: {
          ...state.sharesForOpportunity,
          loading: false,
          error: null,
          succeeded: true,
          records: _.get(action.payload, 'records', []),
          pagination: {
            currentPage: _.get(action.payload, 'currentPage', 0),
            totalPages: _.get(action.payload, 'totalPages', 0),
            recordsPerPage: _.get(action.payload, 'recordsPerPage', 0),
            totalRecords: _.get(action.payload, 'totalRecords', 0),
          },
        },
      };
    case FETCHING_HUBSPOT_SHARES_FOR_OPPORTUNITY_FAILED:
      return {
        ...state,
        sharesForOpportunity: {
          ...state.sharesForOpportunity,
          loading: false,
          error: action.payload.error,
          succeeded: false,
        },
      };

    case INVALIDATE_HUBSPOT_CONTACT:
      return {
        ...state,
        contact: {
          ...initialState.contact,
        },
      };
    case INVALIDATE_HUBSPOT_RECOMMENDED_ASSETS:
      return {
        ...state,
        recommendedAssets: {
          ...initialState.recommendedAssets,
        },
      };
    case INVALIDATE_HUBSPOT_SHARES_FOR_OPPORTUNITY:
      return {
        ...state,
        sharesForOpportunity: {
          ...initialState.sharesForOpportunity,
        },
      };
    default:
      return state;
  }
}